// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"58ce53403abf2bf1","5763":"c013dc12b2dea120","6893":"5383a9a4340591df","6974":"c63977895ae2cf00","7222":"8f935950f42d6512","7937":"b3bfdfe5f597f5fe"}[chunkId] + ".js";
};